// extracted by mini-css-extract-plugin
module.exports = {"btns":"OrderLevel_btns__2jg2c","editBtn":"OrderLevel_editBtn__YW9ML","deleteBtn":"OrderLevel_deleteBtn__1qwpH"};